import React from 'react'
import Modal from 'react-modal'
import PropTypes from 'prop-types'
import './modal.css'

const modalStyles = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
  },
  content: {
    position: 'relative',
    top: 'auto',
    left: 'auto',
    right: 'auto',
    bottom: 'auto',
    maxWidth: '960px',
    margin: '32px auto',
    padding: 0,
    border: 0,
  },
}

if (process.env.NODE_ENV !== 'test') Modal.setAppElement('#___gatsby')

const GatsbyModal = ({ openModal, handleClose, children }) => (
  <Modal isOpen={openModal} style={modalStyles} onRequestClose={() => handleClose()}>
    {children}
  </Modal>
)

GatsbyModal.propTypes = {
  openModal: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
}

export default GatsbyModal
